/**
 * 
 * @param {import ("$lib/types").PublicProduct | ??} product 
 * @returns 
 */
export function getProductName(product) {
  let name = product?.short_name?.length > 0 ? product?.short_name : product?.name;
  return name;
}